import { combineTokens } from '@utils/css';

combineTokens("--drawer", {
  amountOfColumns: 5,
  amountOfRows: 1
});
const drawer = "_35sd1ic954i";
const label = "_35slrjoc1b";

export { drawer, label };
import "./molecule.drawer.style.linaria.module.css";
//# sourceMappingURL=molecule.drawer.style.js.map
